/**
 * Cart Saga
 */
/* tslint:disable:space-before-function-paren */

import { sagaAsyncActionWorkerFactory } from '../../utils/saga';
import * as actions from '../actions/cart';
import { addItemToCart, removeItemFromCart, updateCartItemTerms } from '../helpers/cart';

import { effects as fx } from 'redux-saga';
import { Action } from 'typescript-fsa';

type AddItemToCartRequestAction = Action<IRequestAddItemToCartActionPayload>;
type RemoveItemFromCartRequestAction = Action<IRequestRemoveItemFromCartActionPayload>;
type UpdateCartItemTermsRequestAction = Action<IRequestUpdateCartItemTermsActionPayload>;

export function* init() {
  yield fx.all([
    fx.call(watchForAddItemToCart),
    fx.call(watchForRemoveItemFromCart),
    fx.call(watchForUpdateCartItemTerms),
  ]);
}

function* watchForAddItemToCart() {
  while (true) {
    const { payload }: AddItemToCartRequestAction = yield fx.take(actions.requestAddItemToCart);
    try {
      const worker = sagaAsyncActionWorkerFactory<
        IAddItemToCartActionPayload,
        ICartActionResultActionPayload,
        Error,
        Promise<any>
        >(
        actions.addItemToCart,
        addItemToCart,
      );

      const { response, errors } = yield fx.call(worker, payload);

      if (errors) {
        payload.promise.reject(errors);
      } else {
        payload.promise.resolve(response);
      }
    } catch (error) {
      payload.promise.reject(error);
    }
  }
}

function* watchForRemoveItemFromCart() {
  while (true) {
    const { payload }: RemoveItemFromCartRequestAction = yield fx.take(actions.requestRemoveItemFromCart);
    try {
      const worker = sagaAsyncActionWorkerFactory<
        IRemoveItemFromCartActionPayload,
        ICartActionResultActionPayload,
        Error,
        Promise<any>
        >(
        actions.removeItemFromCart,
        removeItemFromCart,
      );
      yield fx.call(worker, payload);
      payload.promise.resolve();
    } catch (error) {
      payload.promise.reject(error);
    }
  }
}

function* watchForUpdateCartItemTerms() {
  while (true) {
    const { payload }: UpdateCartItemTermsRequestAction = yield fx.take(actions.requestUpdateCartItemTerms);
    try {
      const worker = sagaAsyncActionWorkerFactory<
        IUpdateCartItemTermsActionPayload,
        ICartActionResultActionPayload,
        Error,
        Promise<any>
        >(
        actions.updateCartItemTerms,
        updateCartItemTerms,
      );
      yield fx.call(worker, payload);
      payload.promise.resolve();
    } catch (error) {
      payload.promise.reject(error);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/sagas/cart.ts